import { NotificationManager, PaymentV2Api } from '@atlas/core';

import { clampAmountToLimits } from 'src/helpers/clampAmountToLimits';

export const buildPaymentUrl = (base, amount, pm) => {
  const clampedAmount = clampAmountToLimits(amount, pm);
  return clampedAmount ? `${base}?amount=${clampedAmount}` : base;
};

export const showAlternativeMethodsOrError = async ({
  fallbackError,
  onSelectMethod,
  onViewAll,
  operationType,
  pmId,
}) => {
  try {
    const response = await PaymentV2Api.getAlternativeMethods({
      altToPmId: pmId,
      operationType,
    });

    const methods = response?.data ?? [];

    if (methods.length > 0) {
      NotificationManager.display({
        data: { methods, onSelectMethod, onViewAll },
        type: 'alternativeMethods',
      });
    } else {
      fallbackError();
    }
  } catch {
    fallbackError();
  }
};
